var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-post height-100vh"}},[_c('h1',{staticClass:"heading--invisible"},[_vm._v(_vm._s(_vm.h1Content))]),_vm._v(" "),_c('div',{staticClass:"form-section-static first-section xs-fill-white "},[_c('div',{staticClass:"contact_content bg-opacity p-10"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27a6ef30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/static/Post.vue
// module id = bJoD
// module chunks = 27